// External
import { createSlice } from "@reduxjs/toolkit";

import questionsData from '../../static/questions.json'
// Initial State
const initialState = {
	questions: questionsData
		.sort((questionA, questionB) => {
			if (questionA.list > questionB.list) return 1
			else if (questionA.list < questionB.list) return -1
			else return 0
		}),
};
// Question Reducer
const questions = createSlice({
	name: "questions",
	initialState,
	reducers: { // This reducer is only used with internal action defined here
	}
});
export default questions.reducer;
